import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { ApiError } from './lib/api';
import './index.css';

const client = new QueryClient({
    defaultOptions: {
        queries: {
            // A 401 or a 404 is an answer. Retrying it delays the real one.
            retry: (failureCount, error) => {
                if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
                return failureCount < 2;
            },
            refetchOnWindowFocus: false,
            staleTime: 10_000,
        },
    },
});

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <QueryClientProvider client={client}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </QueryClientProvider>
    </StrictMode>,
);
